import { useState } from 'react'

import qs from 'qs'

import {
  LoadingContainer,
  Model,
  Panels,
  Bar,
  Pagination,
} from 'peach/components'
import { useParams } from 'peach/router'

import { R } from 'core/helpers'
import { Page } from 'core/components'
import { isNotFoundError } from 'core/helpers/error'
import { useQueryString } from 'core/hooks'
import { PickRequired, useInternalGetStatements } from 'core/types'
import { InternalGetStatementsVariables } from 'core/types/operations'

const LoanStatements = () => {
  const { companyId, personId, loanId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
  }>()

  const [page, setPage] = useState(1)

  const [query, setQuery] = useQueryString<
    PickRequired<
      NonNullable<InternalGetStatementsVariables['query']>,
      'limit' | 'startingAfter' | 'endingBefore'
    >
  >({
    limit: 50,
    startingAfter: '',
    endingBefore: '',
  })

  const {
    data: statements,
    pagination: { total: count, nextUrl, previousUrl } = {},
    isLoading,
    error,
  } = useInternalGetStatements({
    companyId,
    personId,
    loanId,
    query,
    options: { throwOnError: R.isNot(isNotFoundError) },
  })

  const nextStatement = qs.parse(nextUrl ?? '')?.startingAfter
  const previousStatement = qs.parse(previousUrl ?? '')?.endingBefore

  return (
    <Panels
      header={
        <Bar
          left={
            <Pagination
              limit={query.limit ?? 0}
              onChange={(direction) => {
                if (direction === 'previous') {
                  setQuery({
                    ...query,
                    startingAfter: '',
                    endingBefore: page > 2 ? previousStatement : '',
                  })
                  setPage(page - 1)
                } else {
                  setQuery({
                    ...query,
                    startingAfter: nextStatement,
                    endingBefore: '',
                  })
                  setPage(page + 1)
                }
              }}
              page={page}
              total={count}
              variant='compact'
            />
          }
          title='Statements'
        />
      }
    >
      <LoadingContainer error={error} loading={isLoading}>
        <Page variant='full'>
          <Model.Item json={statements} />
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default LoanStatements
